module.exports = __webpack_public_path__ + "img/product-4-2.103ffbb0.png";